import React from 'react';
import EtcProjectListContainer from '../../containers/etcmng/EtcProjectListContainer';

const EtcListPage = () => {
  const pageUrl = '/etcmng';
  return <EtcProjectListContainer pageUrl={pageUrl} />;
};

export default EtcListPage;
